<template>
  <div class="login-page">
    <img class="logo" alt :src="images.logo" />
    <div class="bg"></div>
    <div class="login-panel">
      <p class="info">Please login your account</p>
      <div @click="checkLogin" tabindex="-1" class="login-btn text-center">
        <img :src="images.gLogo" alt />
        <span class="b">Continue With Google</span>
      </div>
      <div @click="oktaLogin()" tabindex="-1" class="login-btn okta-btn text-center">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36">
            <path d="M19.8,.26l-.74,9.12c-.35-.04-.7-.06-1.06-.06-.45,0-.89,.03-1.32,.1l-.42-4.42c-.01-.14,.1-.26,.24-.26h.75l-.36-4.47c-.01-.14,.1-.26,.23-.26h2.45c.14,0,.25,.12,.23,.26h0Zm-6.18,.45c-.04-.13-.18-.21-.31-.16l-2.3,.84c-.13,.05-.19,.2-.13,.32l1.87,4.08-.71,.26c-.13,.05-.19,.2-.13,.32l1.91,4.01c.69-.38,1.44-.67,2.23-.85L13.63,.71ZM7.98,3.25l5.29,7.46c-.67,.44-1.28,.96-1.8,1.56l-3.17-3.12c-.1-.1-.09-.26,.01-.35l.58-.48-3.15-3.19c-.1-.1-.09-.26,.02-.35l1.87-1.57c.11-.09,.26-.07,.34,.04ZM3.54,7.57c-.11-.08-.27-.04-.34,.08l-1.22,2.12c-.07,.12-.02,.27,.1,.33l4.06,1.92-.38,.65c-.07,.12-.02,.28,.11,.33l4.04,1.85c.29-.75,.68-1.45,1.16-2.08L3.54,7.57ZM.55,13.33c.02-.14,.16-.22,.29-.19l8.85,2.31c-.23,.75-.36,1.54-.38,2.36l-4.43-.36c-.14-.01-.24-.14-.21-.28l.13-.74-4.47-.42c-.14-.01-.23-.14-.21-.28l.42-2.41h0Zm-.33,5.98c-.14,.01-.23,.14-.21,.28l.43,2.41c.02,.14,.16,.22,.29,.19l4.34-1.13,.13,.74c.02,.14,.16,.22,.29,.19l4.28-1.18c-.25-.74-.41-1.53-.45-2.34L.21,19.31Zm1.42,6.34c-.07-.12-.02-.27,.1-.33l8.26-3.92c.31,.74,.73,1.43,1.23,2.05l-3.62,2.58c-.11,.08-.27,.05-.34-.07l-.38-.66-3.69,2.55c-.11,.08-.27,.04-.34-.08l-1.23-2.12Zm10.01-1.72l-6.43,6.51c-.1,.1-.09,.26,.02,.35l1.88,1.57c.11,.09,.26,.07,.34-.04l2.6-3.66,.58,.49c.11,.09,.27,.07,.35-.05l2.52-3.66c-.68-.42-1.31-.93-1.85-1.51Zm-1.27,10.45c-.13-.05-.19-.2-.13-.32l3.81-8.32c.7,.36,1.46,.63,2.25,.78l-1.12,4.3c-.03,.13-.18,.21-.31,.16l-.71-.26-1.19,4.33c-.04,.13-.18,.21-.31,.16l-2.3-.84h0Zm6.56-7.75l-.74,9.12c-.01,.14,.1,.26,.23,.26h2.45c.14,0,.25-.12,.23-.26l-.36-4.47h.75c.14,0,.25-.12,.24-.26l-.42-4.42c-.43,.07-.87,.1-1.32,.1-.36,0-.71-.02-1.06-.07h0ZM25.76,1.94c.06-.13,0-.27-.13-.32l-2.3-.84c-.13-.05-.27,.03-.31,.16l-1.19,4.33-.71-.26c-.13-.05-.27,.03-.31,.16l-1.12,4.3c.8,.16,1.55,.43,2.25,.78L25.76,1.94h0Zm5.02,3.63l-6.43,6.51c-.54-.58-1.16-1.09-1.85-1.51l2.52-3.66c.08-.11,.24-.14,.35-.05l.58,.49,2.6-3.66c.08-.11,.24-.13,.34-.04l1.88,1.57c.11,.09,.11,.25,.02,.35Zm3.48,5.12c.13-.06,.17-.21,.1-.33l-1.23-2.12c-.07-.12-.23-.15-.34-.08l-3.69,2.55-.38-.65c-.07-.12-.23-.16-.34-.07l-3.62,2.58c.5,.62,.91,1.31,1.23,2.05l8.26-3.92Zm1.3,3.32l.42,2.41c.02,.14-.07,.26-.21,.28l-9.11,.85c-.04-.82-.2-1.6-.45-2.34l4.28-1.18c.13-.04,.27,.05,.29,.19l.13,.74,4.34-1.13c.13-.03,.27,.05,.29,.19h0Zm-.41,8.85c.13,.03,.27-.05,.29-.19l.42-2.41c.02-.14-.07-.26-.21-.28l-4.47-.42,.13-.74c.02-.14-.07-.26-.21-.28l-4.43-.36c-.02,.82-.15,1.61-.38,2.36l8.85,2.31h0Zm-2.36,5.5c-.07,.12-.23,.15-.34,.08l-7.53-5.2c.48-.63,.87-1.33,1.16-2.08l4.04,1.85c.13,.06,.18,.21,.11,.33l-.38,.65,4.06,1.92c.12,.06,.17,.21,.1,.33l-1.22,2.12h0Zm-10.07-3.07l5.29,7.46c.08,.11,.24,.13,.34,.04l1.87-1.57c.11-.09,.11-.25,.02-.35l-3.15-3.19,.58-.48c.11-.09,.11-.25,.01-.35l-3.17-3.12c-.53,.6-1.13,1.13-1.8,1.56h0Zm-.05,10.16c-.13,.05-.27-.03-.31-.16l-2.42-8.82c.79-.18,1.54-.47,2.23-.85l1.91,4.01c.06,.13,0,.28-.13,.32l-.71,.26,1.87,4.08c.06,.13,0,.27-.13,.32l-2.3,.84h0Z" fill="currentColor" fill-rule="evenodd"></path>
          </svg>
          <span class="b">Continue With Okta</span>
      </div>
      <p v-if="oktaError" class="okta-result">{{ oktaError }}</p>
    </div>
    <img class="flight" alt :src="images.loginFlight" />
  </div>
</template>
<script>
import config from "../core/config";
import images from "../core/images";
import { mapActions } from "vuex";

const OKTA_ISSUER = process.env.VUE_APP_OKTA_ISSUER;
const OKTA_CLIENT_ID = process.env.VUE_APP_OKTA_CLIENT_ID;
const OKTA_REDIRECT_URI =
  process.env.VUE_APP_OKTA_REDIRECT_URI || window.location.origin + "/login";
const OKTA_ALLOWED_HOSTS = (process.env.VUE_APP_OKTA_ALLOWED_HOSTS || "")
  .split(",")
  .map(x => x.trim().toLowerCase())
  .filter(Boolean);
const resolveIssuer = iss => {
  try {
    const url = new URL(iss);
    if (
      url.protocol !== "https:" ||
      !OKTA_ALLOWED_HOSTS.includes(url.hostname.toLowerCase())
    ) {
      return null;
    }
    return url.origin + new URL(OKTA_ISSUER).pathname;
  } catch (e) {
    return null;
  }
};
const b64url = buf =>
  btoa(String.fromCharCode(...new Uint8Array(buf)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
const rand = () => b64url(crypto.getRandomValues(new Uint8Array(32)));
const decodeJwt = t => {
  try {
    const p = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(
      decodeURIComponent(
        atob(p)
          .split("")
          .map(c => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
          .join("")
      )
    );
  } catch (e) {
    return null;
  }
};

export default {
  created() {
    this.initGapi();
    this.handleOktaCallback();
    this.handleOktaIss();
  },
  data() {
    return {
      oktaError: "",
      gu: {},
      gApiLoaded: false
    };
  },
  methods: {
    handleOktaIss() {
      const params = new URLSearchParams(window.location.search);
      if (params.has("code") || params.has("error")) return;
      const issuer = resolveIssuer(params.get("iss"));
      if (issuer) this.oktaLogin(issuer);
    },
    async oktaLogin(issuer = OKTA_ISSUER) {
      const verifier = rand();
      const state = rand();
      const nonce = rand();
      const challenge = b64url(
        await crypto.subtle.digest("SHA-256", new TextEncoder().encode(verifier))
      );
      sessionStorage.setItem("okta_pkce", JSON.stringify({ verifier, state, nonce, issuer }));
      const q = new URLSearchParams({
        client_id: OKTA_CLIENT_ID,
        response_type: "code",
        scope: "openid email profile",
        redirect_uri: OKTA_REDIRECT_URI,
        state,
        nonce,
        code_challenge: challenge,
        code_challenge_method: "S256"
      });
      window.location.href = `${issuer}/v1/authorize?${q}`;
    },
    async handleOktaCallback() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const error = params.get("error");
      if (!code && !error) return;
      let saved = {};
      try {
        saved = JSON.parse(sessionStorage.getItem("okta_pkce")) || {};
        sessionStorage.removeItem("okta_pkce");
      } catch (e) {
        saved = {};
      }
      if (!saved.state) return;
      window.history.replaceState(null, "", window.location.pathname);
      if (error) {
        this.oktaError = params.get("error_description") || error;
        return;
      }
      if (params.get("state") !== saved.state) {
        this.oktaError = "state mismatch";
        return;
      }
      try {
        const res = await fetch(`${saved.issuer || OKTA_ISSUER}/v1/token`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: new URLSearchParams({
            grant_type: "authorization_code",
            client_id: OKTA_CLIENT_ID,
            redirect_uri: OKTA_REDIRECT_URI,
            code,
            code_verifier: saved.verifier
          })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error_description || data.error);
        const idToken = decodeJwt(data.id_token);
        const nonceMatch = !!idToken && idToken.nonce === saved.nonce;
        if (!nonceMatch) throw new Error("nonce mismatch");
        await this.loginWithOkta(data.id_token);
      } catch (e) {
        this.oktaError = e.message;
      }
    },
    initGapi() {
      if (!window.gapi) {
        setTimeout(this.initGapi, 200);
        return;
      }
      new Promise((rs, rj) => {
        if (!window.gapi.auth2) {
          window.gapi.load("auth2", () => {
            window.gapi.auth2
              .init({
                hosted_domain: "tigerairtw.com",
                client_id: config.GOOGLE_CLIENT_ID
                // scope: "email profile openid",
                // response_type: "id_token permission"
              })
              .then(() => rs(window.gapi.auth2))
              .catch(ex => rj(ex));
          });
        } else {
          rs(window.gapi.auth2);
        }
      }).then(() => (this.gApiLoaded = true));
    },
    checkLogin() {
      if (this.gApiLoaded) {
        this.login(window.gapi.auth2);
      } else {
        //this.forceLogin();
      }
    },
    ...mapActions(["login","loginWithOkta","forceLogin"])
  },
  computed: {
    images: () => images
  }
};
</script>
<style lang="scss" scoped>
.login-page {
  overflow-x: hidden;
  .logo {
    top: 10%;
    left: 50%;
    width: 50%;
    position: fixed;
    max-width: 30rem;
    transform: translateX(-50%);
    @media (max-height: 620px) {
      width: 70%;
      top: 1.5rem;
    }
    @media (max-width: 768px) {
      width: 65%;
    }
    @media (max-width: 512px) {
      width: 75%;
    }
  }
  .flight {
    position: absolute;
    position: fixed;
    left: 50%;
    top: 27%;
    z-index: 1;
    width: 36%;
    max-width: 30rem;
    min-width: 20rem;
    transform: translateX(-15%);
    @media (max-height: 768px) {
      top: 24%;
      width: 30%;
    }
    @media (max-width: 1280px) {
      top: 30%;
    }
    @media (max-width: 768px) {
      width: 50%;
      transform: translateX(-20%);
    }
    @media (max-width: 512px) {
      width: 70%;
      transform: translateX(-35%);
    }
  }

  .bg {
    left: 0;
    bottom: 0;
    width: 100vw;
    width: 100%;
    height: 40%;
    z-index: -1;
    position: absolute;
    background: url("../assets/imgs/login-bg.svg");
  }
  .login-panel {
    left: 50%;
    top: 50%;
    width: 40%;
    padding: 2rem;
    min-width: 20rem;
    font-size: 1rem;
    position: absolute;
    background-color: white;
    transform: translateX(-50%);
    box-shadow: $common-shadow;
    border: 1px solid $gray;
    border-radius: $border-radius;
    .info {
      font-size: 1.25rem;
    }
    .login-btn {
      outline: none;
      line-height: 3.6;
      cursor: pointer;
      border-radius: $border-radius;
      border: solid 1px $light-black;
      img {
        width: 2rem;
        margin-right: 1rem;
      }
    }
  }
}
.okta-btn {
  svg {
    width: 2rem;
    margin-right: 1rem;
    vertical-align: middle;
  }
  outline: none;
  line-height: 3.6;
  cursor: pointer;
  margin-top: 1rem;
  border-radius: $border-radius;
  border: solid 1px $light-black;
}
.okta-result {
  margin-top: 1rem;
  overflow: auto;
  max-height: 40vh;
  font-size: 0.75rem;
  text-align: left;
  word-break: break-all;
  white-space: pre-wrap;
}
</style>